const BASE_LEN = 65;
const MARGIN = 3;

export default [
  {
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    i: "10",
    width: BASE_LEN - MARGIN*2,
    height: BASE_LEN - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 1,
    y: 0,
    w: 1,
    h: 1,
    i: "11",
    width: BASE_LEN - MARGIN*2,
    height: BASE_LEN - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 1,
    y: 1,
    w: 1,
    h: 1,
    i: "12",
    width: BASE_LEN - MARGIN*2,
    height: BASE_LEN - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 0,
    y: 1,
    w: 1,
    h: 1,
    i: "13",
    width: BASE_LEN - MARGIN*2,
    height: BASE_LEN - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 2,
    y: 0,
    w: 4,
    h: 2,
    i: "14",
    width: BASE_LEN*4 - MARGIN*2,
    height: BASE_LEN*2 - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#3cb371',
    }
  },
  {
    x: 0,
    y: 2,
    w: 4,
    h: 4,
    i: "15",
    width: BASE_LEN*4 - MARGIN*2,
    height: BASE_LEN*4 - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#000',
    }
  },
  {
    x: 4,
    y: 2,
    w: 2,
    h: 2,
    i: "16",
    width: BASE_LEN*2 - MARGIN*2,
    height: BASE_LEN*2 - MARGIN*2,
    rotateX: 0,
    frontStyle: {
      'background-color': '#8a2be2'
    },
    topStyle: {
      'background-color': '#1E90FF'
    },
    backStyle: {
      'background-color': 'yellow'
    },
    bottomStyle: {
      'background-color': 'green'
    },
    perspective: 0
  },
  {
    x: 4,
    y: 4,
    w: 2,
    h: 2,
    i: "17",
    width: BASE_LEN*2 - MARGIN*2,
    height: BASE_LEN*2 - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#4169e1',
    }
  },
  {
    x: 0,
    y: 6,
    w: 4,
    h: 2,
    i: "18",
    width: BASE_LEN*4 - MARGIN*2,
    height: BASE_LEN*2 - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#4169e1',
    }
  },
  {
    x: 4,
    y: 6,
    w: 2,
    h: 2,
    i: "19",
    width: BASE_LEN*2 - MARGIN*2,
    height: BASE_LEN*2 - MARGIN*2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#cd5c5c'
    }
  }
]
